import { useNavigate } from 'react-router-dom'
import { useEffect, useState, useRef } from "react";
import Layout from '../../Layout/Layout';
import { Cookies } from 'react-cookie';
import { ToastContainer, toast } from 'react-toastify';
import Loader from '../../Layout/Loader';
import { ClearSession } from '../../Common/Common'
import Footer from '../../Layout/FooterComponent';


const cookies = new Cookies();

const ChangePassword = ({ open }) => {
    useEffect(() => {
        document.title = 'Change Password'
    }, [])
    const [changePasswordData, setChangePasswordData] = useState({ oldPassword: '', newPassword: '', confirmPassword: '' })
    const inputRefs = useRef([]);
    const [SessionClear, SetSessionClear] = useState(false);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const Token = cookies.get('token');
    const LoginUserCode = cookies.get('loginUserCode');
    const source = 'web'
    const handleSubmit = async (event) => {
        event.preventDefault();
        const data = {
            Token,
            LoginUserCode,
            OldPassword: changePasswordData.oldPassword,
            NewPassword: changePasswordData.newPassword,
            ConfirmPassword: changePasswordData.confirmPassword,
            Source: source
        }
        setIsLoading(true);
        await fetch(`/api/User/ChangePassword`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json"
            },
        }).then(async (response) => {
            const res = await response.json();
            if (res.status === 'SUCCESS') {
                setIsLoading(false)
                toast.success(res.message, {
                    position: 'top-center'
                })
                SetSessionClear(true);
            }
            else if (res.message === "EXPIRED") {
                SetSessionClear(true);
                ClearSession();
            }
            else {
                setIsLoading(false)
                toast.error(res.message, {
                    position: 'top-center'
                }) 
            }
            inputRefs.current[res.focus].focus()
        }).catch((err) => {
            setIsLoading(false)
            toast.error(err.message, {
                position: 'top-center'
            });
            
        })
        
    }

    const handleReset = () => {
        setChangePasswordData({ ...changePasswordData, newPassword: '', confirmPassword: '' })
    }

    useEffect(() => { inputRefs.current['txtOldPassword'].focus() }, [])

    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{'Change Password'}</h6>
                                </div>
                            </div>
                            <div className="form-box service-content-area">
                                <div className="w-100 row gap-2 py-2 px-auto">
                                    <div className="col-lg-4 col-md-6 col-sm-12 px-2 mx-4" >
                                        <div className="fields">
                                            <label className="form-label">Old Password <span className="Required">*</span></label>
                                            <input
                                                ref={ref => (inputRefs.current['txtOldPassword'] = ref)}
                                                type="password"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        inputRefs.current['txtNewPassword'].focus();
                                                    };

                                                }
                                                }
                                                className={`form-control`}
                                                autoComplete="off"
                                                maxLength='15'
                                                minLength='8'
                                                placeholder='Old Password'
                                                name='oldPassword'
                                                value={changePasswordData.oldPassword}
                                                onChange={(e) => setChangePasswordData({ ...changePasswordData, oldPassword: e.target.value })}
                                            />
                                        </div>
                                        <div className="fields">
                                            <label className="form-label">New Password <span className="Required">*</span></label>
                                            <input
                                                ref={ref => (inputRefs.current['txtNewPassword'] = ref)}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        inputRefs.current['txtConfirmPassword'].focus();
                                                    };

                                                }}
                                                maxLength='15'
                                                minLength='8'
                                                type="password"
                                                placeholder='New Password'
                                                className="form-control"
                                                autoComplete="off"
                                                name='oldPassword'
                                                value={changePasswordData.newPassword}
                                                onChange={(e) => setChangePasswordData({ ...changePasswordData, newPassword: e.target.value })}
                                            />
                                        </div>
                                        <div className="fields">
                                            <label className="form-label">Confirm Password <span className="Required">*</span></label>
                                            <input
                                                ref={ref => (inputRefs.current['txtConfirmPassword'] = ref)}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        handleSubmit(e);  
                                                    };
                                                }
                                                }
                                                maxLength='15'
                                                minLength='8'
                                                type="password"
                                                className="form-control"
                                                placeholder='Confirm Password'
                                                autoComplete="off"
                                                name='oldPassword'
                                                value={changePasswordData.confirmPassword}
                                                onChange={(e) => setChangePasswordData({ ...changePasswordData, confirmPassword: e.target.value })}
                                            />
                                        </div>
                                        <div className="col-lg-12">
                                            <div className="lms-new-button text-center">
                                                <button className="button save-btn" onClick={handleSubmit}>
                                                    <i className="bi bi-check-lg" /> Change Password
                                                </button>
                                                <button className="button reset-btn" onClick={handleReset}>
                                                    <i className="bi bi-arrow-clockwise" />Reset
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-lg-6 col-md-6 border password-policy-border p-0 border-1 mx-4 my-sm-2'>
                                        <div className='w-100 password-policy py-2 px-3'>
                                            <h6 className="m-0 font-weight-bold text-white">{'Password Policy'}</h6>
                                        </div>
                                        <div className='px-2 py-2'>
                                            <div className="form-group px-2">
                                                <li>White spaces are not allowed.</li>
                                                <li>Password must be between 8 to 15 character(s).</li>
                                                <li>Password must be combination of atleast one numeric and one upper case letter and Special character [@@$#!() ], white spaces are not allowed.</li>
                                                <li>New password and confirm password must be same.</li>
                                                <li>Old password and New password should be different.</li>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <ToastContainer theme='colored' />
            {isLoading ? <Loader text='Please wait' size='100px' img_path='./assets/img/giphy.gif' /> : <></>}
            {SessionClear ? <ClearSession /> : <></>}
            <Footer/>
        </main>
    )
}
export default ChangePassword;



